module.exports = __webpack_public_path__ + "media/question3_au.e6c90b83.mp3";